import React from 'react'
import './teacher-invitation-screen.css'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {baseUrl} from '../assets/Animations'
import { MdCheck, MdClose } from 'react-icons/md';
import { GuitarPlayerSVG } from '../NewStudentForm/AutoFillNewStudentForm/ConfirmationPage/GuitarPlayerSVG';
import ErrorGuySVG from '../NewStudentForm/AutoFillNewStudentForm/ConfirmationPage/ErrorGuySVG';

const TeacherInvitationScreen = () => {
    const [loading, setLoading] = React.useState(true)
    const [response, setResponse] = React.useState(null)
    const [error, setError] = React.useState(false)
    let {invitationId, answer} = useParams()

    React.useEffect(() => {
        submitAnswer()
    },[])
    
    const submitAnswer = async () => {
        axios.put(`${baseUrl}/teacher-invitations/${invitationId}/${answer}`
        ).then((response) => {
            setResponse(response.data)
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
            console.log(error)
            setError(true)
        })
    }

    const generateEmailFromSchool = (school) => {
        if(school === 'mma') {
            return 'info@mountainsidemusicacademy.com'
        } else if(school === 'lsma') {
            return 'info@lakesidemusicacademy.com'
        } else if(school === 'tma') {
            return 'info@treesidemusicacademy.com'
        } else if(school === 'mor') {
            return 'info@morningsidemusicacademy.com'
        } else if(school === 'psma') {
            return 'info@parksidemusicacademy.com'
        }  else if(school === 'tem') {
            return 'info@tempemusicacademy.com'
        }  else if(school === 'den') {
            return 'info@dentonmusicacademy.com'
        }  else if(school === 'tul') {
            return 'info@tulsamusicacademy.com'
        }
    }

    if(!error) {
        return (
            <div className='teacher-invitation-screen__wrapper'>
                {
                loading 
                ? 
                    <div className='teacher-invitation-screen__loading'>Submitting answer...</div>
                :
                <div>
                    {
                    answer === '1' ?
                        <div className='teacher-invitation-screen__response__wrapper'>
                            <div className='teacher-invitation-screen__response-title'>Thanks for your response!</div>
                            <div className='teacher-invitation-screen__response-body'>
                                <div>You have answered that you're <span style={{color: '#14B8A6'}}>interested</span> in this prospective student.</div>
                            </div>
                            <div className='teacher-invitation-screen__response-body'>
                                <div>We will let you know if the family is interested in moving forward. There may be other teachers interested, so your quick response will increase your chances of acquiring this student.</div>
                            </div>
                            <GuitarPlayerSVG className="teacher-invitation-screen__guitar-player" />
                        </div>
                    :
                        <div className='teacher-invitation-screen__response__wrapper'>
                            <div className='teacher-invitation-screen__response-title'>Thanks for your response!</div>
                            <div className='teacher-invitation-screen__response-body'>
                                <div>You have <span style={{color: '#EF4444'}}>declined</span> this prospective student.</div>
                                <div>If this was by mistake, or you change your mind, please send us an <a className='teacher-invitation-screen__email-link' href={`mailto:${generateEmailFromSchool(response.school)}`}>email</a></div>
                            </div>
                            <GuitarPlayerSVG className="teacher-invitation-screen__guitar-player" />
                        </div>
                    }
                </div>
                }
            </div>
        )
    } else {
        return (
            <div className='teacher-invitation-screen__wrapper'>
                <div className='teacher-invitation-screen__response__wrapper'>
                    <div className='teacher-invitation-screen__response-title'>Uh-oh!</div>
                        <div className='teacher-invitation-screen__response-body'>Something went wrong.</div>
                        <div className='teacher-invitation-screen__response-body'>Please send us an email with your preference. If you are interested in this prospective student, we'll be sure to get you on the list.</div>
                        <div style={{fontStyle: 'italic'}} className='teacher-invitation-screen__response-body'>Thanks!</div>
                    <ErrorGuySVG />
                </div>
            </div>
        )
    }
}
export default TeacherInvitationScreen;